import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this._outsideClickHandler = this._handleOutsideClick.bind(this)
    this._escapeHandler = this._handleEscape.bind(this)
    this._closeAllHandler = this._handleCloseAll.bind(this)
    document.addEventListener("nav-dropdown:close-all", this._closeAllHandler)
  }

  disconnect() {
    this._removeDocumentListeners()
    document.removeEventListener("nav-dropdown:close-all", this._closeAllHandler)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.element.classList.contains("is-open")) {
      this._close()
    } else {
      document.dispatchEvent(
        new CustomEvent("nav-dropdown:close-all", { detail: { except: this.element } })
      )
      this._open()
    }
  }

  close(event) {
    if (event) {
      event.stopPropagation()
    }
    this._close()
  }

  _open() {
    this.element.classList.add("is-open")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this._outsideClickHandler)
    document.addEventListener("keydown", this._escapeHandler)
  }

  _close() {
    this.element.classList.remove("is-open")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this._removeDocumentListeners()
  }

  _removeDocumentListeners() {
    document.removeEventListener("click", this._outsideClickHandler)
    document.removeEventListener("keydown", this._escapeHandler)
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }

  _handleEscape(event) {
    if (event.key === "Escape") {
      this._close()
      this.triggerTarget.focus()
    }
  }

  _handleCloseAll(event) {
    if (event.detail?.except !== this.element) {
      this._close()
    }
  }
}
